"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getInputFiles", {
    enumerable: true,
    get: function() {
        return getInputFiles;
    }
});
const _expandInputPatterns = require("./expandInputPatterns.js");
function getInputFiles(target, dependencyMap, packageTree) {
    const inputs = target.inputs ?? [
        "**/*"
    ];
    const packagePatterns = (0, _expandInputPatterns.expandInputPatterns)(inputs, target, dependencyMap);
    const files = [];
    for (const [pkg, patterns] of Object.entries(packagePatterns)){
        const packageFiles = packageTree.getPackageFiles(pkg, patterns);
        files.push(...packageFiles);
    }
    return files;
}
